import { InjectionToken, NgModule } from '@angular/core';
import { CoupledWindowService } from './coupled-window.service';
import { EditingCoupledWindowService } from './editing-coupled-window.service';

export const GlobalCoupledWindowService = new InjectionToken<CoupledWindowService>('coupled_window_service');

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [
        CoupledWindowService,
        { provide: GlobalCoupledWindowService, useExisting: CoupledWindowService },
        EditingCoupledWindowService
    ],
})
export class CoupledWindowModule {}
